import React from "react";
import styles from "./styles.module.css"
import { FaStar } from "react-icons/fa";

const StarRating = ({ rating, numRatings }) => {
    return (
        <div className={styles.star_rating}>

            <div className={styles.star_rating_stars}>
                {[1, 2, 3, 4, 5].map((index) => (
                    <span
                        key={index}
                        className={styles.star}
                        id={index <= rating ? styles.filled : ""}
                    >
                        <FaStar />
                    </span>
                ))}
            </div>
            <div className={styles.star_rating_text}>
                {rating.toFixed(1)} ({numRatings})
            </div>
        </div>
    );
};

export default StarRating;
